import React from 'react';
import cn from 'classnames';

import ITag from 'shared/model/ITags';
import {truncate} from 'shared/lib/format/string';

import styles from './RowTags.module.scss';

interface IRowTagsProps {
    tags: (ITag | string)[],
    // eslint-disable-next-line no-unused-vars
    onTagClick?: (tag: string) => void,
    disabled?: boolean,
}

const RowTags: React.FC<IRowTagsProps> = ({tags, onTagClick, disabled}) => (
    <div className={cn(
        styles.tags,
        styles.color,
    )}>
        {tags.map((tag, index) => {
            const label = typeof tag === 'object' ? tag.label : tag;

            return (
                <span
                    key={index}
                    title={label}
                    className={cn(onTagClick && !disabled && styles.clickable)}
                    onClick={onTagClick && ((event) => {
                        event.stopPropagation();

                        if (!disabled) {
                            onTagClick(label);
                        }
                    })}
                >
                    {truncate(label)}
                </span>
            );
        })}
    </div>
);

export default RowTags;
